import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { isArray } from 'lodash';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { SimpleTable } from '~/components';
import { Input } from '~/components/Form';
import { t } from '~/helpers';
import api from '~/services/api';
import { FormWrapper } from './styles';
import * as S from './styles';

export default function MyForm({ data, reference, close }) {

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        movi_totalizador_veiculo_novo: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(0),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
      };

      await api.put('alterartotalizadorabastecimento', objSend);
      toast.success(t('s.geral.sucessoalteracao'));

      await close();
    } catch (err) {
      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }

      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    reference.current.setData(data);
  }, []);

  return (
    <>
      <S.Wrapper>
        <FormWrapper ref={reference} initialData={data} onSubmit={handleSubmit}>
          <Input
            name="fatu_codigo"
            value={data.fatu_codigo}
            label="Pré-Fatura:"
            disabled
          />
          <Input
            name="data.orgao_nome"
            label="Órgão:"
            value={data.orga_nome}
            disabled
          />
          <SimpleTable
            style={{ width: '100px' }}
            url="radpesquisaprefaturaunidatahistoricoitem"
            cells={[
              {
                id: 'fahi_data_str',
                label: 'Data',
              },
              {
                id: 'fahi_contestacao',
                label: 'Contestação',
              },
              {
                id: 'usua_login',
                label: 'Login',
              },
              {
                id: 'fahi_descricao',
                label: 'Descrição',
              },
            ]}
            unique={['fatu_codigo', 'fahi_codigo']}
            form={MyForm}
            onCreate={false}
            onUpdate={false}
            onDelete={false}
            title={'Histórico Pré-fatura'}
            restProps={''}
            query={{
              wherefield: ['fatu_codigo'],
              valuewherefield: [data.fatu_codigo],
              typewherefield: ['EQUALS'],
              pagesize: 99999,
            }}
          />
        </FormWrapper>
      </S.Wrapper>
    </>
  );
}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
};
